import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ICompanyNote } from '~/types/note/models'

export const {
  getNoteListData: getCompanyNoteListData,
  getNoteDataById: getCompanyNoteDataById,
  getNoteListDataByParentId: getCompanyNoteListDataByCompanyId,
} = makeNoteMockData<ICompanyNote>({
  entityName: 'company',
  storageKeyPrefix: 'company',
})
